export default "__VITE_ASSET__BrB8ISw4__"